import { Directive, HostListener } from '@angular/core'

/**
 * Stops a click from bubbling to ancestor click handlers when it is the tail end of a mouse drag
 * (text selection) rather than an intentional click.
 *
 * Browsers dispatch `click` on the nearest common ancestor of mousedown and mouseup, so finishing
 * a text-selection drag over a row inside `ionic-selectable` fires the row's `<ion-item (click)>`
 * and toggles the selection (ASPIK-1235). Attach to the row's template wrapper:
 *
 *   <div class="ionicSelectableItemTemplateWrapper" appIgnoreClickAfterTextDrag>
 */
@Directive({
  selector: '[appIgnoreClickAfterTextDrag]',
  standalone: true,
})
export class IgnoreClickAfterTextDragDirective {
  private static readonly DRAG_THRESHOLD_PX = 5

  private downX: number = null
  private downY: number = null

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.downX = event.clientX
    this.downY = event.clientY
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    // Keyboard-triggered clicks have detail === 0 and no meaningful coordinates.
    if (event.detail === 0) return

    const pointerMoved =
      this.downX != null &&
      (Math.abs(event.clientX - this.downX) > IgnoreClickAfterTextDragDirective.DRAG_THRESHOLD_PX ||
        Math.abs(event.clientY - this.downY) > IgnoreClickAfterTextDragDirective.DRAG_THRESHOLD_PX)
    const hasTextSelection = !!window.getSelection()?.toString()

    if (pointerMoved || hasTextSelection) {
      event.stopPropagation()
      event.preventDefault()
    }
  }
}
